import { render } from "./SedesList.vue?vue&type=template&id=eef4c72e&scoped=true"
import script from "./SedesList.vue?vue&type=script&lang=js"
export * from "./SedesList.vue?vue&type=script&lang=js"

import "./SedesList.vue?vue&type=style&index=0&id=eef4c72e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef4c72e"]])

export default __exports__